import { render, staticRenderFns } from "./InvestorNotificationsView.vue?vue&type=template&id=0220042a&scoped=true"
import script from "./InvestorNotificationsView.vue?vue&type=script&lang=js"
export * from "./InvestorNotificationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220042a",
  null
  
)

export default component.exports